import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const StyledForm = styled.div`
    height: auto;
    flex: 1 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @media screen and (min-width: ${theme.breakpoints[0]}) {
        width: 434px;
    }

    > form {
        display: flex;
        flex-direction: column;
        height: 100%;

        @media screen and (min-width: ${theme.breakpoints[0]}) {
            height: auto;
        }
    }

    .content-text-validator {
        text-align: justify;
    }

    .password-criteria {
        margin-top: 10px;
    }

    .confirm-password {
        margin-top: 20px;
    }

    .help-button {
        display: flex;
        font-size: 14px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: 0em;
        text-align: center;
        justify-content: flex-start;
        width: auto;
        margin-left: -1.5em;
    }

    .textInput > span {
        white-space: normal;
    }
`

export const TextFieldContainer = styled.div`
    margin-top: 1.5rem;

    span > text {
        width: 100px;
    }
`
